import { createContext, useCallback, useMemo, useState } from "react";
import UpdateBannerModal from "./components/UpdateBannerModal";
import { PromoBanner } from "src/api/types";

type ContextType = {
  banner: PromoBanner | null;
  setBanner: (banner: PromoBanner) => void;
};

export const UpdateBannerContext = createContext<ContextType>({
  banner: null,
  setBanner: () => {},
});

interface Props {
  children: React.ReactNode;
}

const UpdateBannerProvider = ({ children }: Props) => {
  const [bannerToUpdate, setBannerToUpdate] = useState<PromoBanner | null>(
    null
  );

  const handleClose = useCallback(() => {
    setBannerToUpdate(null);
  }, []);

  const values = useMemo(
    () => ({
      banner: bannerToUpdate,
      setBanner: setBannerToUpdate,
    }),
    [bannerToUpdate]
  );

  return (
    <UpdateBannerContext.Provider value={values}>
      {children}
      {bannerToUpdate ? (
        <UpdateBannerModal
          open={true}
          onClose={handleClose}
          banner={bannerToUpdate}
        />
      ) : null}
    </UpdateBannerContext.Provider>
  );
};

export default UpdateBannerProvider;
